import { render, staticRenderFns } from "./clientStats.vue?vue&type=template&id=03ba5997&scoped=true"
import script from "./clientStats.vue?vue&type=script&lang=js"
export * from "./clientStats.vue?vue&type=script&lang=js"
import style0 from "./clientStats.vue?vue&type=style&index=0&id=03ba5997&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ba5997",
  null
  
)

export default component.exports